import { Button, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'src/app/common/hook/translation.hook';
import { exportBdmBatchFilePolicies, exportBdmHoldPolicies } from '../../network/opm-pd-bdm';
import { exportLmBatchFilePolicies } from '../../network/opm-pd-lm';

type ExportButtonProps = {
  module: 'bdmBatchFilePolicies' | 'bdmHoldPolicies' | 'lmBatchFilePolicies';
  batchId?: string;
};

const ExportButton = (props: ExportButtonProps) => {
  const { module, batchId } = props;

  const [isExporting, setIsExporting] = useState(false);

  const t = useTranslation();
  const dispatch = useDispatch();

  const exportApiMap = {
    bdmBatchFilePolicies: exportBdmBatchFilePolicies,
    bdmHoldPolicies: exportBdmHoldPolicies,
    lmBatchFilePolicies: exportLmBatchFilePolicies,
  } as Record<string, Function>;

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const blob = (await exportApiMap[module](batchId, dispatch)) as Blob;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'policy-list.xlsx';
      link.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleExport}
      disabled={isExporting}
      startIcon={isExporting ? <CircularProgress size={16} color="inherit" /> : undefined}
    >
      {t('opm_pd.export')}
    </Button>
  );
};

export default ExportButton;
